<template>
  <div class="submission-page">
    <app-header />
    <deals-list :loggedIn="true" />
    <submission-form v-if="!isSubmitted" @submitted="showSuccessMessage" />
    <success-message v-if="isSubmitted" />
    <how-it-works />
  </div>
</template>

<script>
import AppHeader from '@/components/common/app-header'
import DealsList from '@/components/deals/list'
import SubmissionForm from '@/components/submission/submission-form'
import HowItWorks from '@/components/submission/how-it-works'
import SuccessMessage from '@/components/submission/success-message'

export default {
  name: 'Home',
  components: {
    AppHeader,
    DealsList,
    SubmissionForm,
    HowItWorks,
    SuccessMessage
  },
  data () {
    return {
      isSubmitted: false
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters['user/isLoggedIn']
    }
  },
  watch: {
    isLoggedIn (v) {
      if (v) {
        this.$router.push({ name: 'deals' })
      }
    }
  },
  methods: {
    showSuccessMessage () {
      this.isSubmitted = true
      this.$ga.page({
        page: this.$route.path + '/submit/success',
        title: 'Deal learn more view'
      })
    }
  }
}
</script>
